export enum DateFormat {
  Croatian = 'DD.MM.YYYY',
  English = 'MM/DD/YYYY',
  ShoppingCart = 'DD.MM.',
  YearMonthDay = 'YYYY-MM-DD',
  DayMonth = 'DD.MM',
}
